import axios from "axios"
import route from '../router'
export default {
    namespaced: true,
    state:{
        user:{},
        auth:false,
        token: localStorage.getItem('access_token') || null,
        loader: false,
        welcome:false, // mostrar o no el mensaje de bienvenida
        modoClientes:false,
        verifyEmail:false,
        solicitudPassword:false
    }, 
    getters:{
        
        gett_user(state){
            let usr = state.user
            return usr
        },
        isAuth(state)
        {
            return !!state.token
        }
    },
    mutations:{
        SET_USER(state, user){
            if(user == null)
            {
                state.user = {
                    
                    nombre:"----", 
                    apellido_paterno:"----",

                }
            }else{
                state.user = user
                state.auth = Boolean(user)
            }
        },
        SET_TOKEN(state, token)
        {
            state.token = token
        },
        LOADING(state){
            state.loader = !state.loader
        },
        WELCOME(state)
        {
            state.welcome = !state.welcome
        },
        VERIFYEMAIL(state)
        {
            state.verifyEmail = !state.verifyEmail
        }
    },
    actions:{

       
        // devuelve el usuario actualmente autenticado
        getUser({commit, state}){
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token') 
            axios.post('user').then(res=>{
                commit('SET_USER', res.data)
                commit('WELCOME')
                //console.clear()
                
            })
            .catch((e)=>{
               
                //console.clear()
                if (e.response.status == 403) {
                    console.log(e.response.data);
                    commit('VERIFYEMAIL')
                    state.token = null
                }
                commit('SET_USER', null)
                localStorage.removeItem('access_token')
            })
        },

        // cierra la sesión
        logout({ commit, dispatch }){
            axios.post('logout', {brand:3}).then(()=>{
                localStorage.removeItem('access_token')
                if (route.history.current.name != "Home") {
                    route.push({name: "Home"})
                }
                location.reload()
            })
        },
    }
}